import { Filter, Loader2 } from "lucide-react";

export default function PayoutBatchForm({
  data, setData,
  tipoPag, setTipoPag, paymentTypes,
  obs, setObs,
  onSubmit, submitting, selectedCount,
}) {
  return (
    <div className="bg-[#FAF8F2] border border-[#E6E1D6] rounded-md p-4 mb-3 flex flex-wrap items-end gap-3">
      <div className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold mr-2 flex items-center gap-1">
        <Filter size={12} /> Defaults do lote
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">Data *</label>
        <input type="date" value={data} onChange={(e) => setData(e.target.value)}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829]"
          data-testid="batch-date" />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">Tipo Pagamento *</label>
        <select value={tipoPag} onChange={(e) => setTipoPag(e.target.value)}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded bg-white outline-none focus:border-[#0F1829]"
          data-testid="batch-tipo">
          <option value="" disabled>— Escolhe —</option>
          {paymentTypes.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
        </select>
      </div>
      <div className="flex flex-col gap-1 flex-1 min-w-[200px]">
        <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">Observações (default)</label>
        <input type="text" value={obs} onChange={(e) => setObs(e.target.value)}
          placeholder="ex: Transferência Fev/2026"
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829]"
          data-testid="batch-obs" />
      </div>
      <button onClick={onSubmit} disabled={submitting || selectedCount === 0}
        className="px-4 py-2 text-sm bg-[#0F1829] text-white rounded hover:bg-black disabled:opacity-40 flex items-center gap-1.5 font-bold"
        data-testid="batch-submit">
        {submitting && <Loader2 size={14} className="animate-spin" />}
        Registar {selectedCount > 0 ? `${selectedCount} pagamento${selectedCount === 1 ? "" : "s"}` : "Lote"}
      </button>
    </div>
  );
}
